import React from "react";
import { useNavigate } from "react-router-dom";

const CategoryCard = (props) => {
  const {
    category_name,
    category_description,
    category_id,
    tagsList,
    credentials_count,
    thumbnail_image_1,
  } = props;
  const navigate = useNavigate();
  const categoryKey = category_id ?? "unknown";
  const isInteractive = Boolean(category_id && category_name);
  const categoryPath = isInteractive
    ? `/certificates/${category_name.replace(/ /g, "+")}/${category_id}`
    : null;
  const interactiveProps = isInteractive
    ? {
        role: "button",
        tabIndex: 0,
        onClick: () => navigate(categoryPath),
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            navigate(categoryPath);
          }
        },
      }
    : {};
  return (
    <div
      id={`category-card-${categoryKey}`}
      className={`group flex flex-col gap-3 bg-cfSecondary border border-cfCardBorder ${
        isInteractive &&
        "cursor-pointer hover:bg-cfCardHover hover:scale-105"
      } transition-all duration-500 rounded-2xl overflow-hidden w-[19.125rem]`}
      {...interactiveProps}
    >
      <div className="flex flex-col h-full">
        <div className="flex flex-col h-fit">
          <div
            id={`category-card-thumbnail-${categoryKey}`}
            className={`flex items-center h-44 w-full bg-cfSearchContainer ${
              !thumbnail_image_1 && "w-full animate-pulse bg-zinc-300"
            }`}
          >
            <img
              src={thumbnail_image_1}
              // onError={(e)=> HandleImgError(e,thumbnail_image_1)}
              alt=""
              className="w-32 h-32 object-cover mx-auto"
            />
            {/* <div className="w-1/2 h-full border-l">
            <img
              src={thumbnail_image_2}
              // onError={(e)=> HandleImgError(e,thumbnail_image_2)}
              alt=""
              className={`w-full ${(thumbnail_image_2 && thumbnail_image_3) ? "h-1/2" : thumbnail_image_2 && "h-full"} object-cover`}
            />
            <hr />
              <img src={thumbnail_image_3} 
              onError={(e)=> HandleImgError(e,thumbnail_image_3)}
              alt="" 
              className={`w-full ${(thumbnail_image_2 && thumbnail_image_3) ? "h-1/2" : thumbnail_image_3 && "h-full"} object-cover`}
              />
            </div> */}
          </div>
        </div>

        <div className=" h-36 pt-2.5 px-3 border-t">
          <div className="h-10  overflow-ellipsis font-medium text-lg flex items-center">
            <p
              id={`category-card-name-${categoryKey}`}
              className={`line-clamp-1 ${
                !category_name && "h-8 w-full animate-pulse bg-zinc-300 rounded-md"
              }`}
            >
              {category_name}
            </p>
            <p>
              ({credentials_count})
              </p>
          </div>
          <div className={`h-10 `}>
            <p
              className={`text-xs line-clamp-2 ${
                !category_description &&
                "h-8 w-full animate-pulse bg-zinc-300 text-gray-400 rounded-md"
              }`}
            >
              {category_description}
            </p>
          </div>
          <div className="flex gap-1 my-2 h-8">
            {tagsList ? (
              tagsList.slice(0,2).map((item, index) => (
                <p
                  key={index}
                  className=" text-xs bg-cfCardTagFill text-cfCardTagText font-medium group-hover:bg-cfTagFillHover group-hover:text-cfSecondary w-fit px-2 py-1 rounded-full h-fit"
                >
                  {item}
                </p>
              ))
            ) : (
              <>
                <p className="h-5 w-4/12 animate-pulse text-xs bg-zinc-300 px-2 py-1 rounded-full"></p>
                <p className="h-5 w-5/12 animate-pulse text-xs bg-zinc-300 px-2 py-1 rounded-full"></p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CategoryCard;
